import EvidenceFigure from './EvidenceFigure';
import { urlImpactOf, urlImpactValue } from './urlImpact';

type UrlImpactFigureProps = {
  name: string;
  affectedUrlCount: number;
  crawledUrlCount: number;
};

function UrlImpactFigure({ name, affectedUrlCount, crawledUrlCount }: UrlImpactFigureProps) {
  const impact = urlImpactOf(affectedUrlCount, crawledUrlCount);

  return (
    <EvidenceFigure
      name={name}
      help={impact.share === null ? undefined : `${impact.share} of the URLs crawlers requested`}
      className="diagnostics-evidence-figure-apart"
    >
      {urlImpactValue(impact)}
    </EvidenceFigure>
  );
}

export default UrlImpactFigure;
